import React from 'react'
import ResetPasswordForm from '../../../features/user/components/ResetPasswordForm/ResetPasswordForm'
import PageLayout from '../../../components/organismes/PageLayout/PageLayout'

export default function ResetPasswordPage() {
  return (
    <PageLayout>
      <ResetPasswordForm />
    </PageLayout>
  )
}
